'use client'

import { useCallback } from 'react'
import { useCustomRouter } from '@/root/shared-hooks'

export const useActionsButtonHandlers = (reservationId: number, reservationToken: string) => {
  const { locale, push } = useCustomRouter()

  const previewUrl = `/api/reservation/${reservationId}/preview/${locale}/${reservationToken}`
  const printUrl = `/${locale}/ticket/${reservationToken}/print`

  const onDownload = () => window.open(previewUrl, '_blank')

  const onPrint = useCallback(() => {
    const printWindow = window.open(printUrl, '_blank', 'noopener,noreferrer')

    if (!printWindow) {
      push(printUrl)
    }
  }, [printUrl, push])

  const cancelUrl = `/${locale}/refund/${reservationToken}`
  const onCancel = () => push(cancelUrl)

  const editUrl = `/${locale}/edit-reservation/${reservationToken}`
  const onEdit = () => push(editUrl)

  const onViewClick = () => push(`/${locale}/ticket/${reservationToken}`)

  return { onDownload, onPrint, onCancel, onEdit, onViewClick, previewUrl, printUrl, cancelUrl, editUrl }
}
